import auth from '../api/auth';
import session from '../api/session';

import {
  LOGIN_BEGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  SET_TOKEN,
  SET_USERNAME,
  SET_LOGIN_DATA,
  REMOVE_LOGIN_DATA,
  GET_PROFILE,
  UPDATE_PROFILE,
  ERROR_PROFILE
} from './types';

const TOKEN_STORAGE_KEY = 'token';
const USER_STORAGE_KEY = 'user';

const initialState = {
  authenticating: false,
  error: false,
  token: null,
  username: null,
  first_name: null,
  avatar: null,
  loginRequestError: [],
  profileRequestError: [],
};

const getters = {
  isAuthenticated: state => !!state.token,
};

const actions = {
  login({ commit }, { username, password }) {
    commit(LOGIN_BEGIN);
    return auth.login(username, password)
      .then(({ data }) => { commit(SET_LOGIN_DATA, data); })
      .catch(({ data }) => { auth.dumpRequestResponse(data); commit(LOGIN_FAILURE); });
  },
  logout({ commit }) {
    return auth.logout()
      .then(() => commit(LOGOUT))
      .finally(() => commit(REMOVE_LOGIN_DATA));
  },
  updateProfile({ commit }, data) {
    return auth.updateAccountDetails(data)
      .then(({ data }) => { commit(UPDATE_PROFILE); return data; })
      .catch(({ data }) => { auth.dumpRequestResponse(data); commit(ERROR_PROFILE); });
  },
  getProfile({ commit }) {
    return auth.getAccountDetails()
      .then(({ data }) => { commit(GET_PROFILE); return data; })
      .catch(({ data }) => { auth.dumpRequestResponse(data); commit(ERROR_PROFILE); });
  },
  getSocialAccounts({ commit }) {
    return auth.getSocialAccounts()
      .then(({ data }) => { return data; })
      .catch(({ data }) => { auth.dumpRequestResponse(data); commit(ERROR_PROFILE); });
  },
  socialDisconnect({ commit }, pk) {
    return auth.socialDisconnect(pk)
      .then(({ data }) => { commit(LOGOUT); return data; })
      .catch(({ data }) => { auth.dumpRequestResponse(data); commit(ERROR_PROFILE); });
  },
  setLoginData({ commit }, data) {
    return commit(SET_LOGIN_DATA, data);
  },
  initialize({ commit }) {
    const token = window.$cookies.isKey(TOKEN_STORAGE_KEY);
    const user = window.$cookies.isKey(USER_STORAGE_KEY);

    if (token) {
      var myToken = window.$cookies.get(TOKEN_STORAGE_KEY);
      commit(SET_TOKEN, myToken);
      if (user) {
        var myUser = window.$cookies.get(USER_STORAGE_KEY);
        myUser = JSON.parse(atob(myUser));
        commit(SET_USERNAME, myUser);
      }
      commit(LOGIN_SUCCESS);
    } else {
      commit(REMOVE_LOGIN_DATA);
    }
  },
};

const mutations = {
  [LOGIN_BEGIN](state) {
    state.authenticating = true;
    state.error = false;
  },
  [LOGIN_FAILURE](state) {
    state.authenticating = false;
    state.error = true;
    let data = auth.getRequestResponse();
    state.loginRequestError = data;
  },
  [GET_PROFILE](state) {
    state.profileRequestError = null;
  },
  [UPDATE_PROFILE](state) {
    state.profileRequestError = null;
  },
  [ERROR_PROFILE](state) {
    let data = auth.getRequestResponse();
    state.profileRequestError = data;
  },
  [LOGIN_SUCCESS](state) {
    state.authenticating = false;
    state.error = false;
    state.loginRequestError = null;
  },
  [LOGOUT](state) {
    state.authenticating = false;
    state.error = false;
  },
  [SET_TOKEN](state, token) {
    session.defaults.headers.common.Authorization = `Token ${token}`;
    state.token = token;
  },
  [SET_USERNAME](state, data) {
    state.username = data.username;
    state.first_name = data.first_name;
    state.avatar = data.avatar;
  },
  [SET_LOGIN_DATA](state, data) {
    let objectUser = {
      'username': data.username,
      'first_name': data.first_name,
      'avatar': data.avatar
    };
    /* seta o cookie do token */
    if ( data.key ){
      window.$cookies.set(TOKEN_STORAGE_KEY, data.key);
      session.defaults.headers.common.Authorization = `Token ${data.key}`;
      state.token = data.key;
    }
    /* seta o objeto do usuario base64 */
    window.$cookies.set(USER_STORAGE_KEY, btoa(JSON.stringify(objectUser)));
    state.username = data.username;
    state.first_name = data.first_name;
    state.avatar = data.avatar;
  },
  [REMOVE_LOGIN_DATA](state) {
    window.$cookies.remove(TOKEN_STORAGE_KEY);
    window.$cookies.remove(USER_STORAGE_KEY);
    delete session.defaults.headers.common.Authorization;
    state.token = null;
    state.username = null;
    state.first_name = null;
    state.avatar = null;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
